import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3),
    width: '100%',
    overflowX: 'auto',
    position: 'relative',
  },
  formControl: {
    marginTop: theme.spacing(1),
    minWidth: 120,
  },
  title: {
    margin: theme.spacing(2),
  },
  buttonGroup: {
    position: 'absolute',
    right: '15px',
    top: '15px',
  },
  button: {
    marginRight: '5px',
  },
  leftIcon: {
    marginRight: '5px',
  },
}));

export default useStyles;
